import React, { useState, useEffect } from 'react';
import vr from '../../../../utils/Verifiers';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import ReporteProyeccion from './ReporteProyeccion';
import img from '../../../../assets/construccion.png';
import AjustadorProyecciones from './AjustadorProyecciones';

const Proyecciones = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [seccion, setseccion] = useState('AJUSTE DE PROYECCIONES');
    useEffect(() => {

    }, []);

    const botonSeccion = (sec) => {
        return (
            <div className="bw p-2 " style={{ '--bw': '200px' }} >
                <button className={`w-100 btn btn-sm transition-s btn-${seccion === sec ? 'warning text-bold ' : 'light shadow '}`} onClick={() => {
                    if (seccion === sec) return;
                    setseccion(sec);
                }}>{sec}</button>
            </div>
        )
    }

    return (
        <>
            <div className="dosis" style={{ width: '100%', height: 'calc(100vh - 100px)', overflow: 'auto' }}>
                <div className={`row d-flex m-0 p-0 justify-content-center`}>
                    {botonSeccion('REPORTE DE PROYECCIONES')}
                    {botonSeccion('AJUSTE DE PROYECCIONES')}
                    {seccion === 'REPORTE DE PROYECCIONES' && <ReporteProyeccion />}
                    {seccion === 'AJUSTE DE PROYECCIONES' && <AjustadorProyecciones />}
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </>
    )
}

export default Proyecciones;